import { composeIO } from 'react-compose-io'
import { fieldsConsiderarTransformacaoApiIO } from './FieldsConsiderarTransformacaoApi.IO'
import { FieldsConsiderarTransformacaoApiView } from './FieldsConsiderarTransformacaoApi.View'

export const FieldsConsiderarTransformacaoApi = composeIO(FieldsConsiderarTransformacaoApiView, fieldsConsiderarTransformacaoApiIO)
